import { useLoggedUserContext } from '../../AppContext';
import sessionClient from '../../infrastructure/sessionClient';
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import UIError from "../UIError";
import LoadingPopup from '../loading/LoadingPopup';
import ErrorPopup from "../error/ErrorPopup";
import "./gamePanel.css";

export default function GamePanel({game, server}) {
    const [loggedUser, setLoggedUser] = useLoggedUserContext();
    const navigate = useNavigate();

    const joinGameQuery = useMutation({mutationFn: async () => await joinGame(game, server)});
    
    const kingdom = findKingdom(game, loggedUser);
    const percentProgress = getPercentProgress(game);

    return <>
        {joinGameQuery.isError && renderError(joinGameQuery.error, setLoggedUser, navigate)}
        {(joinGameQuery.isPending || joinGameQuery.isSuccess) && <LoadingPopup/>}
        <div className='gamePanel' onClick={() => joinGameQuery.mutate()}>
            <table>
                <tbody>
                    <tr>
                        <td><img alt="map type" src="maps/pangea.jpg"/></td>
                        <td>
                            <div className="name">{game.name} #{game.id}</div>
                            <div className="progressBar"><div style={{width: percentProgress}} className="innerProgressBar"></div></div>
                            <div className="param"><img alt="map size" src="./icons/map.png"/> {game.mapDetails.width}x{game.mapDetails.height}</div>
                            {kingdom && <div className="param">
                                <img alt={kingdom.civilization.name} src={`./civilizations/${kingdom.civilization.id}.png`}/> {kingdom.civilization.name}
                            </div>}
                            {kingdom && <div className="param">
                                <img alt="Score and rank" src="./icons/score.png"/> {kingdom.score} #{kingdom.rank}
                            </div>}
                            <div className="param">
                                <img alt="Schedule and time zone" src="./icons/schedule.png"/> Week days 6PM-11PM CET
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </>
}

function getPercentProgress(game) {
    if (game.details) {
        return Math.round(100 * game.details.turn / game.details.endTurn) + "px";
    }
    else {
        return "0%";
    }
}

function findKingdom(game, user) {
    if (game.details) {
        for (const kingdom of game.details.kingdoms) {
            if (kingdom.user.id === user.id) {
                return kingdom;
            }
        }
    }
    return null;
};

async function joinGame(game, server) {
    const res = await sessionClient.getToken();
    
    if (res.ok) {
        const json = await res.json();
        const token = json.token;
        window.location = `${server.url}/api/session/start?token=${token}&gameId=${game.id}`;
    }
    else if (res.status === 401) {
        throw new UIError("UNAUTHORIZED");
    }
    else {
        throw new UIError("Error status code: " + res.status);
    }
}

function renderError(error, setLoggedUser, navigate) {
    if (error.name === "UIError" && error.message === "UNAUTHORIZED") {
        setTimeout(() => {
            setLoggedUser(null);
            navigate('/login');
        });
        return null;
    }

    return <ErrorPopup message={error.message}/>
}
